export const MAP_KEY = process.env.REACT_APP_MAP_KEY;
export const GUEST_LINK = process.env.REACT_APP_GUEST_LINK;
export const CUSTOMER_LINK = process.env.REACT_APP_CUSTOMER_LINK;
export const SITE_KEY = process.env.REACT_APP_RE_CAPTCHA_SITE_KEY;
export const SECRET_KEY = process.env.REACT_APP_RE_CAPTCHA_SECRET_KEY;